module.exports = __webpack_public_path__ + "img/Proxelia_80X30.df4a56fc.png";